import { ref } from 'vue'
const globalIgnoreRefs = ref([])

export function useClickOutsideIgnore() {
    const addIgnoreEl = (el) => {
        globalIgnoreRefs.value.push(el);
    }

    const isInIgnoredElements = (target) => {
        return globalIgnoreRefs.value.some(el => {
            return el?.value?.contains(target)
        })
    }

    return {
        globalIgnoreRefs,
        isInIgnoredElements,
        addIgnoreEl,
    }
}